import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-main-heading',
  templateUrl: './main-heading.component.html',
  styleUrl: './main-heading.component.scss',
  standalone: false,
})
export class MainHeadingComponent {

  @Input() heading: any;
  @Input() label: any;
  @Input() footer: any;

}
